import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {Backdrop, Box, Button, CircularProgress, Typography,} from "@mui/material";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";
import {REPORT_TYPES} from "../../constants";
import {createNewReport} from "../../services/requests/ApiRequests";
import {getQueryParams} from "../../utils";

const ReportDialog = ({message, setError, card, withBackButton}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = useState(true);

	const handleGenerateReport = () => {
		setLoading(true);
		const reqBody = {
			type: REPORT_TYPES.Z,
			card: {
				...card,
				type: 3,
			},
		};
		createNewReport(reqBody)
			.then((data) => {
				const reports = data.data?.data || [];
				if (reports.length) {
					const newReport = reports.find(
						(report) => report?.soap_data?.type === REPORT_TYPES.Z
					);

					setError({
						status: false,
						msg: "",
					});
					setOpen(false);

					window.open(
						`/acps/report/${newReport._id}?${getQueryParams(card)}`,
						"_blank"
					);
				} else {
					setError({
						status: true,
						msg: "There are errors while report generation",
					});
				}
				setLoading(false);
			})
			.catch((error) => {
				const data = error?.response?.data || {};
				const msg =
					data.error || "There are errors while report generation";
				setError({status: true, msg, code: error?.response?.status});
				setLoading(false);
			});
	};

	const handleNavigateBack = () => {
		navigate("/acps");
	};

	return (
		<Backdrop open={open} sx={{zIndex: 99999}}>
			<Box
				style={{
					display: "flex",
					width: 500,
					alignItems: "center",
					flexDirection: "column",
					justifyContent: "center",
					backgroundColor: "#fff",
					padding: 16,
					borderRadius: 5,
				}}
			>
				<WarningAmberIcon color="error" sx={{fontSize: 40}}/>
				<Typography
					variant="body1"
					color={"gray"}
					sx={{textAlign: "center", my: 2}}
				>{t(`${message}`)}</Typography>
				<Button
					variant="outlined"
					onClick={handleGenerateReport}
					disabled={loading}
				>
					{loading && (
						<CircularProgress size={14} sx={{marginRight: 1}}/>
					)}
					{t("z_report")}
				</Button>
				{withBackButton ? (
					<Button
						variant="outlined"
						color="warning"
						onClick={handleNavigateBack}
						disabled={loading}
						sx={{marginTop: 2}}
					>
						{t("back_to_work")}
					</Button>
				) : null}
			</Box>
		</Backdrop>
	);
};

export default ReportDialog;
